import { FC } from 'react';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { FormattedMessage } from 'react-intl';
import TelegramWhiteBg2Svg from '#srcIcons/socials/telegram-white-bg.svg';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { Button, ButtonVariant } from '#components/button';
import { SocialLinkAlias } from '#components/social-link';
import modelDetailContactButtonListCss from '../../assets/model-detail/model-detail-contact-button-list.module.scss';

const Telegram: FC = () => {
  const {
    advert: {
      contactData,
    },
  } = useAdvertDetailContext();

  if (!contactData.socialLinkList) {
    return null;
  }

  const telegram = contactData.socialLinkList.find((socialLink) => socialLink.alias === SocialLinkAlias.telegram);

  if (!telegram) {
    return null;
  }

  return (
    <Button
      variant={ButtonVariant.blue}
      fontWeight600
      linkSimpleProps={{
        href: telegram.url,
        target: '_blank',
        rel: 'noreferrer',
      }}
      contentAdditionalClassName={modelDetailContactButtonListCss.modelDetailContactButtonList__itemContent}
      additionalClassName={modelDetailContactButtonListCss.modelDetailContactButtonList__item}
    >
      <SvgIcon Component={TelegramWhiteBg2Svg} size={16} colored />
      <FormattedMessage defaultMessage="Telegram" />
    </Button>
  );
};

export { Telegram };
